module.exports = __webpack_public_path__ + "static/media/failed.a32d5d9f.png";